jQuery(document).ready(function() {
    jQuery('.js-gallery iframe').each(function() {
        if (jQuery(this).attr('src').indexOf('?') >= 0) {
            jQuery(this).attr('src', jQuery(this).attr('src') + '&rel=0');
        } else {
            jQuery(this).attr('src', jQuery(this).attr('src') + '?rel=0');
        }
    });

    jQuery('.videoWrapper iframe').each(function() {
        if (jQuery(this).attr('src').indexOf('?') >= 0) {
            jQuery(this).attr('src', jQuery(this).attr('src') + '&rel=0');
        } else {
            jQuery(this).attr('src', jQuery(this).attr('src') + '?rel=0');
        }
    });

    jQuery('.u-video iframe').each(function() {
        if (jQuery(this).attr('src').indexOf('?') >= 0) {
            jQuery(this).attr('src', jQuery(this).attr('src') + '&rel=0');
        } else {
            jQuery(this).attr('src', jQuery(this).attr('src') + '?rel=0');
        }
    });
});